import { hexToRgba } from "../../utils/colorUtils";
import { cn } from "../../@shadcn/lib/utils";
import { Check } from "@phosphor-icons/react";

export interface GiftCardProviderChipProps {
  iconUrl: string;
  label: string;
  accentColor: string;
  showCheckBadge?: boolean;
  showLabel?: boolean;
  showAccentRing?: boolean;
}

const GiftCardProviderChip = ({
  iconUrl,
  label,
  accentColor,
  showCheckBadge = true,
  showLabel = true,
  showAccentRing = true,
}: GiftCardProviderChipProps) => {
  const isActive = showCheckBadge && showAccentRing;

  return (
    <div
      className={cn(
        "ui-relative ui-flex ui-flex-col ui-items-center ui-justify-center",
        showLabel &&
          "ui-gap-[6px] ui-rounded-[12px] ui-px-[8px] ui-pb-[8px] ui-pt-[12px] hover:ui-bg-black/[0.04]",
      )}
      style={
        isActive ? { backgroundColor: hexToRgba(accentColor, 0.1) } : undefined
      }
    >
      <div
        className={cn(
          "ui-relative ui-isolate ui-size-[40px] ui-shrink-0 ui-overflow-clip ui-rounded-[12px]",
        )}
        style={
          showAccentRing
            ? {
                boxShadow: `0px 0px 0px 1.5px white, 0px 0px 0px 3px ${accentColor}`,
              }
            : undefined
        }
      >
        <div
          aria-hidden={showLabel}
          className="ui-pointer-events-none ui-absolute ui-inset-0 ui-rounded-[12px]"
        >
          {Boolean(iconUrl) && (
            <img
              alt={showLabel ? "" : label}
              src={iconUrl}
              className="ui-size-full ui-max-w-none ui-rounded-[12px] ui-object-cover"
            />
          )}
        </div>
        {/* Decorative inset border — must paint above the image, so it is a sibling overlay
            rather than an inset shadow on the container (which the image would cover) */}
        <div
          aria-hidden
          className="ui-pointer-events-none ui-absolute ui-inset-0 ui-rounded-[12px]"
          style={{ boxShadow: "inset 0 0 0 1px rgba(0, 0, 0, 0.08)" }}
        />
        {showCheckBadge && (
          <div
            className="ui-absolute ui-right-0 ui-top-0 ui-z-[1] ui-flex ui-size-[18px] ui-items-center ui-justify-center ui-overflow-clip ui-rounded-bl-[6px] ui-text-white"
            style={{ backgroundColor: accentColor }}
          >
            <Check size={10} weight="bold" aria-hidden />
          </div>
        )}
      </div>
      {showLabel && (
        <p
          className={cn(
            "ui-relative ui-shrink-0 ui-whitespace-nowrap ui-text-text-xs-medium [word-break:break-word]",
            !isActive && "ui-text-zinc-800/60",
          )}
          style={isActive ? { color: accentColor } : undefined}
        >
          {label}
        </p>
      )}
    </div>
  );
};

export default GiftCardProviderChip;
